'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    margin-top: 1rem;\n    gap: ', ';\n    width: ', ';\n'], ['\n    display: flex;\n    flex-direction: column;\n    margin-top: 1rem;\n    gap: ', ';\n    width: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n'], ['\n    position: relative;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    gap: 12px;\n    padding: 1rem 3rem 1rem 1rem;\n    margin-bottom: 1rem;\n    border: 1px solid ', ';\n    border-radius: 4px;\n    background-color: white;\n'], ['\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    gap: 12px;\n    padding: 1rem 3rem 1rem 1rem;\n    margin-bottom: 1rem;\n    border: 1px solid ', ';\n    border-radius: 4px;\n    background-color: white;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    flex-grow: 1;\n'], ['\n    flex-grow: 1;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    cursor: pointer;\n    top: 32px;\n    right: ', ';\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    cursor: pointer;\n    top: 32px;\n    right: ', ';\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    cursor: pointer;\n'], ['\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    cursor: pointer;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _metrixCommon = require('metrix-common');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Table = require('../Table');

var _Table2 = _interopRequireDefault(_Table);

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TableGroupContainer = _styledComponents2.default.div(_templateObject, function (_ref) {
    var mobile = _ref.mobile,
        tablet = _ref.tablet,
        desktop = _ref.desktop;
    return mobile && '16px' || tablet && '34px' || desktop && '34px';
}, function (_ref2) {
    var desktop = _ref2.desktop,
        tablet = _ref2.tablet,
        mobile = _ref2.mobile;
    return desktop && '620px' || tablet && '492px' || mobile && '330px';
});

var TableWrapper = _styledComponents2.default.div(_templateObject2);

var PlaceholderWrapper = _styledComponents2.default.div(_templateObject3, _metrixCommon.Colors.StrokeDark);

var WorkflowComponentContainer = _styledComponents2.default.div(_templateObject4);

var DeleteButton = _styledComponents2.default.div(_templateObject5, function (_ref3) {
    var mobile = _ref3.mobile,
        tablet = _ref3.tablet,
        desktop = _ref3.desktop;
    return mobile && '-35px' || tablet && '-40px' || desktop && '-40px';
});

var AddButtonContainer = _styledComponents2.default.div(_templateObject6);

var LocationPinIcon = function LocationPinIcon() {
    return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg',
            width: '20',
            height: '25',
            viewBox: '0 0 20 25'
        },
        _react2.default.createElement('path', { d: 'M6.24999 13.75H8.74999V10.313H11.25V13.751H13.75V7.81404L9.99999 5.31404L6.24999 7.81404V13.75ZM9.99999 21.687C12.1413 19.8096 14.0411 17.6736 15.656 15.328C16.7389 13.844 17.3783 12.0831 17.5 10.25C17.5372 9.22131 17.3637 8.19587 16.9902 7.23664C16.6167 6.27742 16.0511 5.40466 15.328 4.67201C14.6353 3.9653 13.8052 3.40799 12.8888 3.03443C11.9725 2.66088 10.9893 2.47899 9.99999 2.50001C9.01064 2.47899 8.02749 2.66088 7.11113 3.03443C6.19478 3.40799 5.36467 3.9653 4.67199 4.67201C3.94891 5.40466 3.38325 6.27742 3.00974 7.23664C2.63623 8.19587 2.46276 9.22131 2.49999 10.25C2.6217 12.0831 3.26113 13.844 4.34398 15.328C5.95884 17.6736 7.85871 19.8096 9.99999 21.687ZM9.99999 25C7.15505 22.6919 4.6278 20.0177 2.48398 17.047C0.996335 15.0788 0.131281 12.7107 -1.08872e-05 10.247C-0.0637891 8.85842 0.172627 7.47242 0.693104 6.18348C1.21358 4.89454 2.00589 3.73298 3.016 2.77803C4.89354 0.978087 7.3991 -0.0185573 9.99999 1.07265e-05C12.6013 -0.0177516 15.1069 0.979982 16.984 2.78102C17.9941 3.73597 18.7864 4.89753 19.3069 6.18647C19.8274 7.47541 20.0638 8.86142 20 10.25C19.8687 12.7137 19.0036 15.0818 17.516 17.05C15.372 20.0196 12.8447 22.6928 9.99999 25Z',
            fill: _metrixCommon.Colors.StrokeMedium
        })
    );
};

var WorkflowTableGroup = function WorkflowTableGroup(_ref4) {
    var entity = _ref4.entity,
        component = _ref4.component,
        valid = _ref4.valid,
        reference = _ref4.reference,
        context = _ref4.context,
        doSetReturn = _ref4.doSetReturn,
        doReduceDynamicDate = _ref4.doReduceDynamicDate,
        doStep = _ref4.doStep,
        configuration = _ref4.configuration,
        session = _ref4.session,
        culture = _ref4.culture,
        mobile = _ref4.mobile,
        tablet = _ref4.tablet,
        desktop = _ref4.desktop,
        returns = _ref4.returns,
        props = _objectWithoutProperties(_ref4, ['entity', 'component', 'valid', 'reference', 'context', 'doSetReturn', 'doReduceDynamicDate', 'doStep', 'configuration', 'session', 'culture', 'mobile', 'tablet', 'desktop', 'returns']);

    var _useState = (0, _react.useState)(null),
        _useState2 = _slicedToArray(_useState, 2),
        isExpanded = _useState2[0],
        setIsExpanded = _useState2[1];

    var _React$useState = _react2.default.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        placeholderReset = _React$useState2[0],
        setPlaceholderReset = _React$useState2[1];

    var _useState3 = (0, _react.useState)(null),
        _useState4 = _slicedToArray(_useState3, 2),
        showModal = _useState4[0],
        setShowModal = _useState4[1];

    var tableDefinition = component.components.find(function (el) {
        return el.type === 'table';
    });

    var _React$useState3 = _react2.default.useState({}),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        shouldRenderChild = _React$useState4[0],
        setShouldRenderChild = _React$useState4[1];

    var prevTableDtaCount = (0, _react.useRef)();

    var tableEntities = props.return && Array.isArray(props.return.elements) && props.return.elements.find(function (el) {
        return el.code === 'Entities';
    });
    var tableData = tableEntities && tableEntities.elements;
    var tableDataIndex = tableData && props.return.elements.indexOf(tableEntities);

    _react2.default.useEffect(function () {
        if (tableData && tableData.length === 1 || prevTableDtaCount.current && prevTableDtaCount.current !== tableData.length) {
            setIsExpanded(tableData.length - 1);
        }

        if (tableData) {
            var newShouldRenderChild = {};
            for (var i = 0; i < tableData.length; i++) {
                newShouldRenderChild[i] = true;
            }
            setShouldRenderChild(newShouldRenderChild);
        }

        if (tableData && prevTableDtaCount.current !== tableData.length) {
            prevTableDtaCount.current = tableData && tableData.length;
        }
    }, [tableData]);

    var isRules = Boolean(component.elements.find(function (el) {
        return el.code === 'Rules';
    }));
    var rules = isRules && component.elements.find(function (el) {
        return el.code === 'Rules';
    }) && component.elements.find(function (el) {
        return el.code === 'Rules';
    }).elements;
    var allowAdd = isRules && rules.find(function (el) {
        return el.code === 'AllowAdd';
    }) && rules.find(function (el) {
        return el.code === 'AllowAdd';
    }).value === 'true';
    var allowDelete = isRules && rules.find(function (el) {
        return el.code === 'AllowDelete';
    }) && rules.find(function (el) {
        return el.code === 'AllowDelete';
    }).value === 'true';
    var maxCount = isRules && rules.find(function (el) {
        return el.code === 'MaxCount';
    }) && rules.find(function (el) {
        return el.code === 'MaxCount';
    }).value;

    var addButtonLabel = isRules && rules.find(function (el) {
        return el.code === 'AddButtonLabel';
    }) && rules.find(function (el) {
        return el.code === 'AddButtonLabel';
    }).value;
    var modalDeleteHeader = isRules && rules.find(function (el) {
        return el.code === 'ModalDeleteHeader';
    }) && rules.find(function (el) {
        return el.code === 'ModalDeleteHeader';
    }).value;
    var modalDeleteSubHeader = isRules && rules.find(function (el) {
        return el.code === 'ModalDeleteSubHeader';
    }) && rules.find(function (el) {
        return el.code === 'ModalDeleteSubHeader';
    }).value;

    var curentComponentIndex = returns && returns.findIndex(function (x) {
        return x.code === component.code;
    });
    var dotProp = curentComponentIndex >= 0 ? 'returns[' + curentComponentIndex + ']' : '';

    var tablePlaceholderDefinition = component.components.find(function (el) {
        return el.type === 'tablePlaceholder';
    }) && component.components.find(function (el) {
        return el.type === 'tablePlaceholder';
    }).components[0];
    var recursiveTablePlaceholderDefinition = _extends({}, tablePlaceholderDefinition, { recursive: true, reset: placeholderReset
    });

    var addressObject = returns && returns.find(function (el) {
        return el.code === 'Address';
    }) && returns.find(function (el) {
        return el.code === 'Address';
    });
    var isAddress = addressObject && addressObject.elements && addressObject.elements.find(function (el) {
        return el.code === 'Code';
    }) && addressObject.elements.find(function (el) {
        return el.code === 'Code';
    }).value;

    if (addressObject && !isAddress && placeholderReset) setPlaceholderReset(null);

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        showModal !== null && _react2.default.createElement(_metrixCommon.GenericModal, {
            animate: true,
            visible: true,
            closeEvent: function closeEvent() {
                return setShowModal(null);
            },
            items: _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_metrixCommon.Header, { size: _metrixCommon.Sizes.md,
                    text: modalDeleteHeader,
                    bottom: _metrixCommon.Sizes.md
                }),
                _react2.default.createElement(_metrixCommon.Label, { text: modalDeleteSubHeader })
            ),
            actionButtons: [{
                text: 'Cancel', primary: false, clickEvent: function clickEvent() {
                    return setShowModal(null);
                }
            }, {
                text: 'Delete', clickEvent: function clickEvent() {
                    setShowModal(null);
                    doSetReturn({
                        actionType: 'deleteOuter', componentCode: dotProp, index: showModal
                    });
                    doStep('next');
                }, primary: true
            }]
        }),
        _react2.default.createElement(
            TableGroupContainer,
            { mobile: mobile,
                tablet: tablet,
                desktop: desktop
            },
            tableData && tableData.length > 0 && tableData.map(function (table, index) {
                if (!shouldRenderChild[index]) return null;

                var currentPath = dotProp + '.elements[' + tableDataIndex + '].elements[' + index + ']';
                var isDynamicRules = table.elements.find(function (el) {
                    return el.code === 'Rules';
                });
                var dynamicRules = isDynamicRules && isDynamicRules.elements;
                var preventDelete = isDynamicRules && dynamicRules.find(function (el) {
                    return el.code === 'PreventDelete';
                }) && dynamicRules.find(function (el) {
                    return el.code === 'PreventDelete';
                }).value === 'true';

                return _react2.default.createElement(
                    TableWrapper,
                    { key: index,
                        mobile: mobile,
                        tablet: tablet,
                        desktop: desktop
                    },
                    _react2.default.createElement(_Table2.default, { valid: valid,
                        reference: reference,
                        component: tableDefinition,
                        configuration: configuration,
                        session: session,
                        culture: culture,
                        context: context,
                        doReduceDynamicDate: doReduceDynamicDate,
                        doSetReturn: doSetReturn,
                        entity: entity,
                        doStep: doStep,
                        'return': table,
                        returns: returns,
                        dotProp: currentPath,
                        index: index,
                        isExpanded: isExpanded,
                        setIsExpanded: setIsExpanded,
                        mobile: mobile,
                        tablet: tablet,
                        desktop: desktop,
                        shouldRenderChild: shouldRenderChild,
                        setShouldRenderChild: setShouldRenderChild
                    }),
                    allowDelete && !preventDelete && _react2.default.createElement(
                        DeleteButton,
                        { onClick: function onClick() {
                                return setShowModal(index);
                            },
                            mobile: mobile,
                            desktop: desktop,
                            tablet: tablet
                        },
                        _react2.default.createElement(_metrixCommon.ClearIcon, { color: _metrixCommon.Colors.StrokeDark })
                    )
                );
            }),
            allowAdd && (!maxCount || !tableData || tableData.length < maxCount) && _react2.default.createElement(
                _metrixCommon.Container,
                null,
                tablePlaceholderDefinition && _react2.default.createElement(
                    PlaceholderWrapper,
                    null,
                    _react2.default.createElement(LocationPinIcon, null),
                    _react2.default.createElement(
                        WorkflowComponentContainer,
                        null,
                        _react2.default.createElement(_Component2.default, { component: recursiveTablePlaceholderDefinition,
                            valid: valid,
                            reference: reference,
                            configuration: configuration,
                            session: session,
                            culture: culture,
                            context: context,
                            doReduceDynamicDate: doReduceDynamicDate,
                            doSetReturn: doSetReturn,
                            entity: entity,
                            doStep: doStep
                        })
                    )
                ),
                (tablePlaceholderDefinition && isAddress || !tablePlaceholderDefinition) && _react2.default.createElement(
                    AddButtonContainer,
                    { onClick: function onClick() {
                            tablePlaceholderDefinition && setPlaceholderReset(true);
                            doSetReturn({ actionType: 'addOuter', componentCode: dotProp });
                            doStep('next');
                        }
                    },
                    _react2.default.createElement(_metrixCommon.LinkButton, { text: addButtonLabel || 'Add New' })
                )
            )
        )
    );
};

WorkflowTableGroup.propTypes = {
    component: _propTypes2.default.object.isRequired,
    return: _propTypes2.default.object.isRequired,
    returns: _propTypes2.default.array.isRequired,
    reference: _propTypes2.default.object.isRequired,
    context: _propTypes2.default.object.isRequired,
    doSetReturn: _propTypes2.default.func.isRequired,
    doStep: _propTypes2.default.func.isRequired,
    session: _propTypes2.default.object.isRequired,
    culture: _propTypes2.default.object.isRequired,
    configuration: _propTypes2.default.object.isRequired,
    entity: _propTypes2.default.object.isRequired,
    valid: _propTypes2.default.bool.isRequired,
    doReduceDynamicDate: _propTypes2.default.func.isRequired,
    mobile: _propTypes2.default.bool,
    tablet: _propTypes2.default.bool,
    desktop: _propTypes2.default.bool
};

exports.default = WorkflowTableGroup;